export default __webpack_public_path__ + "assets/fonts/Nunito-Italic-f3449811.woff";